import { DependentVerificationStatusTypeEnum } from './dependent-verification-status-type-enum.generated';

const x: { [index: string]: string } = {};
x[DependentVerificationStatusTypeEnum.CompleteEligible] = 'Complete - Eligible';
x[DependentVerificationStatusTypeEnum.NoResponse] = 'No Response';
x[DependentVerificationStatusTypeEnum.IncompleteInsufficientDocumentation] = 'Incomplete - Insufficient Documentation';
x[DependentVerificationStatusTypeEnum.CompleteIneligibleByEmployeeReq] = 'Complete - Ineligible By Employee Req';
x[DependentVerificationStatusTypeEnum.CompleteIneligible] = 'Complete - Ineligible';
x[DependentVerificationStatusTypeEnum.IncompleteNoDependentSSN] = 'Incomplete - No Dependent SSN';
x[DependentVerificationStatusTypeEnum.IncompleteNoStudentVerification] = 'Incomplete - No Student Verification';
x[DependentVerificationStatusTypeEnum.None] = 'None';
x[DependentVerificationStatusTypeEnum.Appealed] = 'Appealed';
export const DependentVerificationStatusTypeEnumDescriptions: { [indexer: string]: string } = x;
